import { connect } from "react-redux";
import CRUDAccess from "../Components/header/CRUDAccess";
import { setEnableCRUD } from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    locale: state.locale,
    enableCRUD: state.enableCRUD,
    nickname: state.authentication.nickname,
  };
};

const mapDispatchToProps = {
  setEnableCRUD,
};

/* Next line links component CRUDAccess, to:
-State variables defined on mapStateToProps
-functions defined on mapDispatchToProps */
export default connect(mapStateToProps, mapDispatchToProps)(CRUDAccess);
